import styled from 'styled-components';

export const Background = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1010;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
`;

export const Container = styled.div<{ width?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: 'Heebo', sans-serif;
  font-size: 16px;
  border-radius: 16px;
  overflow: hidden;
  @media (min-width: 801px) {
    width: ${({ width }) => width};
    max-height: 90%;
  }
  @media (max-width: 800px) {
    width: 100%;
    margin: 10px;
  }
`;

export const TitleSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid #ffffff1f;
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
`;

export const Title = styled.span`
  margin-left: 10px;
`;

export const ModalButton = styled.button`
  background: transparent;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  width: 39px;
  height: 39px;
  border-radius: 8px;
  transition-duration: 0.5s;
  &:hover {
    background: #ffffff1a;
  }
  &:focus {
    background: #ffffff33;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(15px);
  @media (min-width: 481px) {
    min-height: 390px;
  }
`;

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  max-height: 80vh;
  width: 100%;
  transition: border-color 0.125s linear;
  &:hover {
    border-color: #ffffff66;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
    height: 60px;
    width: 6px;
    border-right-style: inset;
    border-right-width: calc(100vw + 100vh);
    border-color: inherit;
  }
  @media (min-width: 481px) {
    max-height: 80vh;
    border-color: rgba(0, 0, 0, 0);
  }
  @media (max-width: 480px) {
    max-height: calc(100dvh - 60px - 20px);
    border-color: #ffffff66;
  }
`;
